import { memo } from "react";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowUp } from "lucide-react";

interface UpgradeButtonProps {
  isCheckingSubscription: boolean;
  onClick: () => void;
  daysRemaining?: number;
}

export const UpgradeButton = memo(({ 
  isCheckingSubscription, 
  onClick, 
  daysRemaining 
}: UpgradeButtonProps) => {
  const getButtonStyle = () => {
    if (daysRemaining && daysRemaining <= 3) {
      return "bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-600 hover:to-orange-600";
    }
    return "bg-gradient-to-r from-blue-400 to-purple-500 hover:from-blue-500 hover:to-purple-600";
  };

  const getButtonText = () => {
    if (isCheckingSubscription) return "Checking subscription...";
    if (daysRemaining && daysRemaining <= 0) return "Trial ended - Upgrade now!";
    if (daysRemaining && daysRemaining <= 3) return "Trial ending soon - Upgrade now!";
    if (daysRemaining && daysRemaining > 0) return "Upgrade to Premium";
    return "Upgrade now";
  };

  return (
    <Button
      onClick={onClick}
      className={`w-full ${getButtonStyle()} text-white transition-all duration-300 shadow-lg hover:shadow-xl`}
      disabled={isCheckingSubscription}
    >
      {isCheckingSubscription ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Checking subscription...
        </>
      ) : (
        <>
          <ArrowUp className="mr-2 h-4 w-4" />
          {getButtonText()}
        </>
      )}
    </Button>
  );
});

UpgradeButton.displayName = 'UpgradeButton';